import { render, staticRenderFns } from "./profile-relationship-network.vue?vue&type=template&id=72f1c7f0&scoped=true&"
import script from "./profile-relationship-network.vue?vue&type=script&lang=js&"
export * from "./profile-relationship-network.vue?vue&type=script&lang=js&"
import style0 from "./profile-relationship-network.vue?vue&type=style&index=0&id=72f1c7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f1c7f0",
  null
  
)

export default component.exports